import { render } from "./ShipmentsInquiryGrid.vue?vue&type=template&id=b992f24a"
import script from "./ShipmentsInquiryGrid.vue?vue&type=script&lang=js"
export * from "./ShipmentsInquiryGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__